module.exports = __webpack_public_path__ + "img/30.7d01ad84.svg";